const csvTemplate = `market_type_id,branch_id,month,year,value,value_type
61dc0fe478124640312033a9,61dc67001249324d94acf7f4,1,2024,6262231137,amount
61dc0fe478124640312033a9,61dc67001249324d94acf7f4,2,2024,2964211599,amount
61dc0fe478124640312033a9,61dd4b7a0215520796af2957,1,2024,6374622615,amount
61dc0fe478124640312033a9,61dd4b7a0215520796af2957,2,2024,3088932265,amount
61dc0fe47812468a442033aa,61dd4b7a0215520796af2957,3,2024,7343767804,amount
61dc0fe47812468a442033aa,61dd4b7a0215520796af2957,4,2024,3329611066,amount
61dc0fe47812468a442033aa,61dd4b7a0215520796af2957,5,2024,6711889059,amount
61dc0fe47812468a442033aa,61dd4b7a0215520796af2957,6,2024,2484928024,amount
61dc0fe47812468a442033aa,61dd4b7a0215520796af2957,7,2024,6560797934,amount
61dc0fe47812468a442033aa,61dd4b7a0215520796af2957,8,2024,1835571240,amount`;

export default csvTemplate;
